<template>
  <treeselect
    :multiple="multiple"
    :value="value"
    @input="updateValue($event)"
    :placeholder="placeholder"
    :options="options"
    :clearable="false"
    :defaultExpandLevel="expandLevel"
    class="sync-dropdownlist-simulation"
    :searchable="searchable"
    :disableBranchNodes="disableBranchNodes"
    :normalizer="normalizer"
  />
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'DropDownTreeList',
  components: {treeselect: Treeselect},
  props: {
    placeholder: {
      type: String,
      default: () => '',
      required: false
    },
    options: {
      type: Array,
      default: () => [],
      required: true
    },
    expandLevel: {
      type: Number,
      default: () => Infinity,
      required: false
    },
    searchable: {
      type: Boolean,
      default: () => false,
      required: false
    },
    disableBranchNodes: {
      type: Boolean,
      default: () => true,
      required: false
    },
    keyMaps: {
      type: Object,
      default: () => ({
        idKey: 'id',
        labelKey: 'label',
        childrenKey: 'children'
      })
    },
    multiple:{
      type: Boolean,
      default: () => false,
      required: false
    },
    value: {
      type: [String, Array],
      default() {
        if (this.multiple) {
          return [];
        }
        return '';
      },
      required: true,
    },
    normalizer: {
      type: Function,
      default: () => {
        return (node) => (
          {
            id: node['id'],
            label: node['label'],
            children: node['children']
          }
        )
      },
      required: false
    }


  },
  data() {
    return {}
  },
  methods: {
    updateValue(newVal){
      console.log('newVal', newVal);
      this.$emit('input', newVal);
    }
  }

}
</script>
<style>
.sync-dropdownlist-simulation .vue-treeselect__control {
  font-size: 14px;
  font-weight: normal;
  color: #6C757D;
}

.sync-dropdownlist-simulation .vue-treeselect__placeholder,
.sync-dropdownlist-simulation .vue-treeselect__single-value {
  font-weight: normal;
  color: #6C757D;
}

.sync-dropdownlist-simulation .vue-treeselect__option {
  font-weight: normal;
  color: #495057;
  font-size: 14px;
}

.sync-dropdownlist-simulation .vue-treeselect__label {
  font-weight: normal;
  color: #495057;
  font-size: 14px;
}

.sync-dropdownlist-simulation div.vue-treeselect__option--selected {
  background-color: #007BFF !important;
  color: #FFFFFF;
}

.sync-dropdownlist-simulation div.vue-treeselect__option--selected label.vue-treeselect__label {
  color: #FFFFFF;
}

.sync-dropdownlist-simulation div.vue-treeselect__option {
  height: 1.9em;
  line-height: 1.9em;
  vertical-align: middle;
}

.sync-dropdownlist-simulation .vue-treeselect__control-arrow {
  width: 7px;
  height: 7px;
  color: #495057;
}
.sync-dropdownlist-simulation{
  border: 1px solid transparent;
  border-radius: 4px;
}
.sync-dropdownlist-simulation.vue-treeselect--focused.vue-treeselect--open {
  border-color: #80bdff;
  -webkit-box-shadow: 0 0 0 3px rgba(0, 123, 255, .25);
  box-shadow: 0 0 0 3px rgba(0, 123, 255, .25);


}

.sync-dropdownlist-simulation .vue-treeselect__menu-container {
  margin-top: 4px;
}

</style>
